import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/data/catalog";

const ProductCard = ({ product, index }) => (
  <motion.article
    data-testid={`product-card-${product.id}`}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className="group"
  >
    <div className="relative aspect-[2.5/3.5] overflow-hidden rounded-sm border border-white/10 bg-[#121212] transition-colors duration-500 group-hover:border-white/30">
      <img
        src={product.image}
        alt={product.name}
        loading="lazy"
        className={`h-full w-full grayscale-[40%] transition-[transform,filter] duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0 ${
          product.contain ? "object-contain p-4" : "object-cover"
        }`}
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-80" />
      <span className="absolute left-4 top-4 font-mono text-[10px] uppercase tracking-[0.2em] text-white/60">
        {String(index + 1).padStart(2, "0")}
      </span>
    </div>
    <div className="mt-5 flex flex-wrap items-start justify-between gap-x-3 gap-y-1">
      <div>
        <h3 className="font-display text-base leading-snug text-[#fafafa] md:text-lg">
          {product.name}
        </h3>
        <p className="mt-1 text-sm font-light text-[#888]">{product.detail}</p>
        <p
          data-testid={`product-availability-${product.id}`}
          className={`mt-2 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] ${
            product.availability ? "text-[#cba153]" : "text-[#25D366]"
          }`}
        >
          <span
            className={`inline-block h-1.5 w-1.5 rounded-full ${
              product.availability ? "bg-[#cba153]" : "bg-[#25D366]"
            }`}
          />
          {product.availability || "Disponibile"}
        </p>
      </div>
      {product.price && (
        <div className="shrink-0 text-right">
          <p className="whitespace-nowrap font-mono text-sm text-[#cba153]">
            {product.price}
          </p>
          <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.15em] text-white/30">
            IVA inclusa
          </p>
        </div>
      )}
    </div>
    <a
      href={waLink(
        product.price
          ? `Ciao! Sono interessato a "${product.name}" (${product.price}). È disponibile?`
          : `Ciao! Sono interessato a "${product.name}". Quando sarà disponibile?`
      )}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`product-whatsapp-${product.id}`}
      className="mt-3 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] text-white/50 transition-colors duration-300 hover:text-[#25D366]"
    >
      <MessageCircle size={13} />
      Ordina
    </a>
  </motion.article>
);

export default ProductCard;
